<template>
	<g id="Background">
		<rect fill="#ffc11d" width="300" height="300" rx="33.22" />
		<path
			fill="#01ad87"
			d="M80.67,15.51v.29A50.14,50.14,0,0,1,30.56,66h-.12A50,50,0,0,1,0,55.76V33.22A33.22,33.22,0,0,1,33.22,0h44.9A50.15,50.15,0,0,1,80.67,15.51Z"
		/>
		<path fill="#01ad87" d="M300,260.27v6.51A33.22,33.22,0,0,1,266.78,300H211.5l-10-81.58Z" />
		<path fill="#ff5b4c" d="M62.9,300H33.22A33.22,33.22,0,0,1,0,266.78V168.72Z" />
		<path fill="#ff5b4c" d="M300,33.22V146.3L201.39,0h65.39A33.22,33.22,0,0,1,300,33.22Z" />
		<rect
			fill="#ff5b4c"
			x="95.76"
			y="-25.47"
			width="8.84"
			height="105.29"
			transform="translate(40.95 112.42) rotate(-70.38)"
		/>
		<rect
			fill="#ff5b4c"
			x="85.86"
			y="77.97"
			width="91.71"
			height="8.84"
			transform="translate(9.87 178.8) rotate(-70.38)"
		/>
		<polygon fill="#ff5b4c" points="63.34 0 60.4 8.28 57.48 16.46 49.17 13.5 49.15 13.49 53.96 0 63.34 0" />
	</g>
</template>
